import api from "../../../utilidades/interceptor";

const urlApi = `${process.env.REACT_APP_API_KEY}/vacant`;

export const getVacantes = async (params) => {
    const result = await api.get(`${urlApi}/vacantes`, { params });
    return result.data;
};

export const createVacante = async (vacante) => {
    const result = await api.post(`${urlApi}/vacantes`, vacante);
    return result.data;
};

export const getPuestos = async () => {
    const result = await api.get(`${urlApi}/puestos`);
    return result.data;
};

export const getEmpleados = async (params) => {
    const result = await api.get(`${urlApi}/empleados`, { params });
    return result.data;
};

export const getZonas = async () => {
    const result = await api.get(`${urlApi}/zonas`);
    return result.data;
};

export const getClientes = async (params) => {
    const result = await api.get(`${urlApi}/clientes`, { params });
    return result.data;
};

export const updateVacante = async (id, vacante) => {
    const result = await api.put(`${urlApi}/vacantes/${id}`, vacante);
    return result.data;
};

export const cambiarEstatusVacante = async (id, data) => {
    const result = await api.patch(`${urlApi}/vacantes/${id}/estatus`, data);
    return result.data;
};